import { useState } from 'react';
import { Button } from 'react-bootstrap';
import InsuranceCardsDialog from './InsuranceCardsDialog';

type Props = {
	patientId: string;
};

const InsuranceCardsButton = (props: Props) => {
	const [openDialog, setOpenDialog] = useState(false);

	return (
		<>
			<Button
				className="btn-fill"
				title="Danh sách thẻ BHYT"
				onClick={() => {
					setOpenDialog(true);
				}}
			>
				<i className="bi bi-card-checklist pe-0 me-0"></i>
			</Button>

			{openDialog && (
				<InsuranceCardsDialog
					open={openDialog}
					onClose={() => setOpenDialog(false)}
					{...props}
				/>
			)}
		</>
	);
};

export default InsuranceCardsButton;
